import style from "./Odesa.Module.css"
import { LangContext } from "../../contexts/Language";
import { useContext, useEffect } from "react";
import { CalendarOdesa } from "../Calendar/Odesa/OdesaCalendar";
import { Carousel } from "../Carousel/Carousel";


export const Odesa = ({ OdesaPhotos }) => {
    const { lang } = useContext(LangContext);

    useEffect(() => {
        const titles = {
            BG: 'Апартамент Одеса - Под наем в Созопол | Морска гледка',
            EN: 'Apartment Odessa - For Rent in Sozopol | Sea View',
            RU: 'Апартамент Одесса - Аренда в Созополе | Вид на море',
            CZ: 'Apartmán Odessa - Pronájem v Sozopolu | Výhled na moře',
        };
        document.title = titles[lang] || titles.BG;
    }, [lang]);

    const gallery = <Carousel photos={OdesaPhotos} />;

    if (lang === 'BG') {
        return (
            <section className="odesa-photos">
                <h2 id="gallery">АПАРТАМЕНТ ОДЕСА - ГАЛЕРИЯ</h2>
                {gallery}
                <h2 id="map">Къде може да ни намерите</h2>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2945.5235633813204!2d27.697201375853204!3d42.41658937118779!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a6c7be0ae1d153%3A0xa82dcaa43176b859!2z0JDQv9Cw0YDRgtCw0LzQtdC90YIg0J7QtNC10YHQsCAvIE9kZXNzYSBhcGFydG1lbnQ!5e0!3m2!1sbg!2sbg!4v1687793263536!5m2!1sbg!2sbg"
                    className="odesa-map"
                    title="Odesa map"
                />
                <h2 id="prices">Цени и удобства</h2>
                <section className="prices-odesa">
                    <section className="price">
                        <div>
                            <h5>Октомври - май</h5>
                            <p>70 EUR</p>
                        </div>
                        <div>
                            <h5>Юни - септември</h5>
                            <p>80 EUR</p>
                        </div>
                    </section>
                    <section className="comfort">
                        <section className="comfort-item">
                            <p>Интернет<i className="fa-solid fa-wifi"></i></p>
                            <p>Телевизия<i className="fa-solid fa-tv"></i></p>
                            <p>Хладилник<i className="fa-solid fa-temperature-low"></i></p>
                        </section>
                        <section className="comfort-item">
                            <p>Климатик<i className="fa-solid fa-snowflake"></i></p>
                            <p>Котлони<i className="fa-solid fa-fire-burner"></i></p>
                            <p>Посуда<i className="fa-solid fa-utensils"></i></p>
                        </section>
                    </section>
                </section>
                <div className="calendar-section">
                    <h2 id="calendar">Заетост</h2>
                    <CalendarOdesa />
                </div>
            </section>
        );
    };

    if (lang === 'EN') {
        return (
            <section className="odesa-photos">
                <h2 id="gallery">APARTMENT ODESSA - GALLERY</h2>
                {gallery}
                <h2 id="map">OUR ADDRESS</h2>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2945.5235633813204!2d27.697201375853204!3d42.41658937118779!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a6c7be0ae1d153%3A0xa82dcaa43176b859!2z0JDQv9Cw0YDRgtCw0LzQtdC90YIg0J7QtNC10YHQsCAvIE9kZXNzYSBhcGFydG1lbnQ!5e0!3m2!1sbg!2sbg!4v1687793263536!5m2!1sbg!2sbg"
                    className="odesa-map"
                    title="Odesa map"
                />
                <h2 id="prices">Prices and comfort</h2>
                <section className="prices-odesa">
                    <section className="price">
                        <div>
                            <h5>October - May</h5>
                            <p>70 EUR</p>
                        </div>
                        <div>
                            <h5>June - September</h5>
                            <p>80 EUR</p>
                        </div>
                    </section>
                    <section className="comfort">
                        <section className="comfort-item">
                            <p>Internet<i className="fa-solid fa-wifi"></i></p>
                            <p>TV<i className="fa-solid fa-tv"></i></p>
                            <p>Refrigerator<i className="fa-solid fa-temperature-low"></i></p>
                        </section>
                        <section className="comfort-item">
                            <p>Air-conditioning<i className="fa-solid fa-snowflake"></i></p>
                            <p>Stove<i className="fa-solid fa-fire-burner"></i></p>
                            <p>Utensils<i className="fa-solid fa-utensils"></i></p>
                        </section>
                    </section>
                </section>
                <div className="calendar-section">
                    <h2 id="calendar">Occupancy</h2>
                    <CalendarOdesa />
                </div>
            </section>
        );
    };

    if (lang === 'RU') {
        return (
            <section className="odesa-photos">
                <h2 id="gallery">АПАРТАМЕНТ ОДЕССА - ГАЛЕРЕЯ</h2>
                {gallery}
                <h2 id="map">Как нас найти</h2>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2945.5235633813204!2d27.697201375853204!3d42.41658937118779!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a6c7be0ae1d153%3A0xa82dcaa43176b859!2z0JDQv9Cw0YDRgtCw0LzQtdC90YIg0J7QtNC10YHQsCAvIE9kZXNzYSBhcGFydG1lbnQ!5e0!3m2!1sbg!2sbg!4v1687793263536!5m2!1sbg!2sbg"
                    className="odesa-map"
                    title="Odesa map"
                />
                <h2 id="prices">Цены и удобства</h2>
                <section className="prices-odesa">
                    <section className="price">
                        <div>
                            <h5>Октябрь - май</h5>
                            <p>70 EUR</p>
                        </div>
                        <div>
                            <h5>Июнь - сентябрь</h5>
                            <p>80 EUR</p>
                        </div>
                    </section>
                    <section className="comfort">
                        <section className="comfort-item">
                            <p>Интернет<i className="fa-solid fa-wifi"></i></p>
                            <p>Телевизор<i className="fa-solid fa-tv"></i></p>
                            <p>Холодильник<i className="fa-solid fa-temperature-low"></i></p>
                        </section>
                        <section className="comfort-item">
                            <p>Кондиционер<i className="fa-solid fa-snowflake"></i></p>
                            <p>Плита<i className="fa-solid fa-fire-burner"></i></p>
                            <p>Посуда<i className="fa-solid fa-utensils"></i></p>
                        </section>
                    </section>
                </section>
                <div className="calendar-section">
                    <h2 id="calendar">Занятость</h2>
                    <CalendarOdesa />
                </div>
            </section>
        );
    };

    if (lang === 'CZ') {
        return (
            <section className="odesa-photos">
                <h2 id="gallery">APARTMÁN ODESSA - GALERIE</h2>
                {gallery}
                <h2 id="map">Kde nás najdete</h2>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2945.5235633813204!2d27.697201375853204!3d42.41658937118779!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a6c7be0ae1d153%3A0xa82dcaa43176b859!2z0JDQv9Cw0YDRgtCw0LzQtdC90YIg0J7QtNC10YHQsCAvIE9kZXNzYSBhcGFydG1lbnQ!5e0!3m2!1sbg!2sbg!4v1687793263536!5m2!1sbg!2sbg"
                    className="odesa-map"
                    title="Odesa map"
                />
                <h2 id="prices">Ceny a vybavení</h2>
                <section className="prices-odesa">
                    <section className="price">
                        <div>
                            <h5>Říjen - květen</h5>
                            <p>70 EUR</p>
                        </div>
                        <div>
                            <h5>Červen - září</h5>
                            <p>80 EUR</p>
                        </div>
                    </section>
                    <section className="comfort">
                        <section className="comfort-item">
                            <p>Internet<i className="fa-solid fa-wifi"></i></p>
                            <p>Televize<i className="fa-solid fa-tv"></i></p>
                            <p>Lednice<i className="fa-solid fa-temperature-low"></i></p>
                        </section>
                        <section className="comfort-item">
                            <p>Klimatizace<i className="fa-solid fa-snowflake"></i></p>
                            <p>Vařič<i className="fa-solid fa-fire-burner"></i></p>
                            <p>Nádobí<i className="fa-solid fa-utensils"></i></p>
                        </section>
                    </section>
                </section>
                <div className="calendar-section">
                    <h2 id="calendar">Obsazenost</h2>
                    <CalendarOdesa />
                </div>
            </section>
        );
    };
};
